/**
 * @file electivesToACTResults.js
 * @author Jake Stark
 * @desc Electives To ACT Results report plugin

*/

/**
 * @module electivesToACTResults
 * @desc electivesToACTResults report plugin
 */

define('plugins/electivesToACTResults',["underscore", "models",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/electivesToACTResults_worldLangs_table.html", "text!plugins/templates/electivesToACTResults_art_table.html", "text!plugins/templates/electivesToACTResults_CTE_table.html", "text!plugins/templates/electivesToACTResults_physicalEducationAndHealth_table.html", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels,
        CardboardModels, CardboardCollections, Util,
        worldLanguagesTemplate, artTemplate, cteTemplate, phyEdTemplate, PluginPieces) {

        console.log("MODULE: electivesToACTResults");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["electivesToACTResultsCOHORTID"],
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "World Language",
                    //titlePath: "highSchoolAcademics.content.1",
                    explanationText: "<p>This report provides district self-reported information about elective course-taking patterns with the ACT scores for high school students in Minnesota. If you do not see your school listed in the drop-down menu, it means that your school did not submit the course enrollment data to the MCCC and course information for your district in not available on this page. The elective course credits threshold is 2. </p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: true,
                    views: [{
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "worldLanguages.charts[0]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "worldLanguages.charts[0]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                    //message: "Sorry."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "worldLanguages.charts[1]",
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "worldLanguages.charts[1]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: worldLanguagesTemplate,
                            dataSourceName: "data",
                            /*errorConditions: [
                                 {
                                     valuePath: "data.data.worldLanguages.charts[0].meta.dataNotAvailableMessage",
                                     isNot: null,
                                     error: {
                                         type: "NoData",
                                      }
                                 }
                             ]*/
                        }
                    ]
                },
                {
                    title: "Arts",
                    //titlePath: "highSchoolAcademics.content.1",
                    explanationText: "<p>This report provides district self-reported information about elective course-taking patterns with the ACT scores for high school students in Minnesota. If you do not see your school listed in the drop-down menu, it means that your school did not submit the course enrollment data to the MCCC and course information for your district in not available on this page. The elective course credits threshold is 2. </p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "art.charts[0]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "art.charts[0]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "data",
                                    valuePath: "value",
                                    seriesDisplayNamePath: "name",
                                    displayNamePath: "name"
                                }

                            ],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "art.charts[1]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "art.charts[1]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: artTemplate,
                            dataSourceName: "data"
                        }
                    ]
                },
                {
                    title: "CTE",
                    //titlePath: "highSchoolAcademics.content.1",
                    explanationText: "<p>This report provides district self-reported information about elective course-taking patterns with the ACT scores for high school students in Minnesota. If you do not see your school listed in the drop down menu, it means that your school did not submit the course enrollment data to the MCCC and course information for your district in not available on this page. The elective course credits threshold is 2. </p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "CTE.charts[0]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "CTE.charts[0]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "CTE.charts[1]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "CTE.charts[1]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: cteTemplate,
                            dataSourceName: "data"
                        }
                    ]
                },
                {
                    title: "Physical Education/Health/Safety",
                    //titlePath: "highSchoolAcademics.content.1",
                    explanationText: "<p>This report provides district self-reported information about elective course-taking patterns with the ACT scores for high school students in Minnesota. If you do not see your school listed in the drop down menu, it means that your school did not submit the course enrollment data to the MCCC and course information for your district in not available on this page. The elective course credits threshold is 2. </p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "physicalEducagtionAndHealth.charts[0]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "physicalEducagtionAndHealth.charts[0]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "{{data.chartTitle}}",
                            dataSourceName: "data",
                            dataPath: "physicalEducagtionAndHealth.charts[1]"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "physicalEducagtionAndHealth.charts[1]",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            unitDec: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            yAxisMax: 36,
                            yAxisTickInterval: 6,
                            showLegend: false,
                            // dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "data",
                                valuePath: "value",
                                seriesDisplayNamePath: "name",
                                displayNamePath: "name"
                            }],
                            errorConditions: [{
                                valuePath: "data.data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.data.meta.dataNotAvailableMessage"
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: phyEdTemplate,
                            dataSourceName: "data",
                        }
                    ]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: "<p>For more information on the catalogue, information reported, and other resources, please visit the <a href='https://education.mn.gov/MDE/dse/datasub/MCCC/' target='_blank'>MCCC webpage</a> on the Minnesota Department of Education's website.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031881&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_hsgrad_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                    enabled: true
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_electivestoactresultscohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
                filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_electivestoactresults_dropdowns.fex"
                    },
                    enabled: true,
                }, 
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_electivestoactresultsbuttons.fex",
                    enabled: true,
                    noViewParams: false
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.Model,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_electivestoactresults.fex",
                    yearPath: "dataYear",

                    enabled: true,
                    /*errorConditions: [
                        {
                            valuePath: "errorMessage",
                            isNot: null,
                            error: {
                                type: "NoData",
                                message: "Sorry, we don't have any data for your selected school/district and year."
                            }
                        }
                    ]*/
                }
            }
        };

        return exports;
    });
